export default __webpack_public_path__ + "static/john-goncalves-wpri-ri-01-dem-congressional-primary-debate-02e087b00cb37687efbb85b74462b590.webp";